import React from 'react';
import Phone, { PhoneInputProps } from 'react-phone-input-2';

import Form from 'src/components/form';

export type Props = {} & PhoneInputProps;

const PhoneInput: React.FC<Props> = ({ ...rest }) => {
  return (
    <Form.Field>
      <Phone
        containerClass="custom_phone_input_container"
        inputClass="custom_phone_input_container_input"
        country={'sg'}
        {...rest}
      />
    </Form.Field>
  );
};

export default PhoneInput;
